<script>

class MMap {
  // eslint-disable-next-line space-before-function-paren
  constructor() {
    this.map = {};
  }

  set (key, value) {
    const keyStr = JSON.stringify(key);
    this.map[keyStr] = { key, value };
  }

  has (key) {
    const keyStr = JSON.stringify(key);
    return this.map[keyStr] !== undefined;
  }

  get (key, defaultValue = null) {
    const keyStr = JSON.stringify(key);
    if (this.map[keyStr] === undefined) {
      return defaultValue;
    } else {
      return this.map[keyStr].value;
    }
  }

  delete (key) {
    const keyStr = JSON.stringify(key);
    delete this.map[keyStr];
  }

  clear () {
    this.map = {};
  }

  asArray () {
    return Object.keys(this.map).map(key => this.map[key]);
  }
}

export default {
  name: 'CardsList',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    groupBy: {
      type: Function,
      default: null
    },
    columnSize: {
      type: String,
      default: '530px'
    }
  },
  computed: {
    itemsList () {
      if (!this.items) {
        return null;
      }
      const map = new MMap();
      if (this.groupBy) {
        this.items.forEach(item => {
          let key = '';
          if (typeof this.groupBy === 'function') {
            key = this.groupBy(item);
          } else {
            key = item[this.groupBy];
          }

          if (!map.has(key)) {
            map.set(key, []);
          }

          map.get(key).push(item);
        });
      } else {
        map.set('', this.items);
      }

      return map.asArray().map(i => ({ group: i.key, items: i.value }));
    },
    columnCss () {
      return 'grid-template-columns: repeat(auto-fill, ' + this.columnSize + ');';
    }
  }
};
</script>
<template>
  <fragment>
    <div
      v-if="!items || (items && items.length === 0)"
      class="no-lines"
    >
      <slot name="empty" />
    </div>
    <div class="cards-list">
      <div
        v-for="(group, groupIndex) in itemsList"
        :key="'group_'+groupIndex"
        :set1="groupValue = group.group"
        :set2="groupedItems = group.items"
        class="card-list-group"
      >
        <div
          v-if="groupValue !== ''"
          class="card-list-group-title"
        >
          <slot
            name="groupTitle"
            :group="groupValue"
            :items="groupedItems"
            :index="groupIndex"
            :groups="itemsList"
          />
        </div>
        <div
          class="card-list-group-content"
          :style="columnCss"
        >
          <v-card
            v-for="(item, itemIndex) in groupedItems"
            :key="groupIndex+'-'+itemIndex"
          >
            <slot
              name="item"
              :item="item"
              :index="itemIndex"
              :group="groupValue"
            />
          </v-card>
        </div>
        <div
          v-if="groupValue !== ''"
          class="card-list-group-footer"
        >
          <slot
            name="groupFooter"
            :group="groupValue"
            :items="groupedItems"
            :index="groupIndex"
            :groups="itemsList"
          />
        </div>
      </div>
    </div>
  </fragment>
</template>

<style lang="scss" scoped>
.card-list-group-title {
  font-weight: bold;
  margin: 2em 0 1em 0;
}
.card-list-group-content {
  display: grid;
  grid-gap: 1em;

  justify-content: space-evenly;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .card-list-group-content {
    display: block;
    .v-card {
      margin: 0.5em 0;
    }
  }
}
</style>
